import { Button, ButtonProps, Flex, Link, LinkProps } from '@rover/kibble/core';

import { ButtonBh } from '@rover/rsdk/src/apiClient/latest';
import { ButtonVariants } from '@rover/kibble/core/Button';
import { LinkVariant } from '@rover/kibble/core/Link/Link.common';
import { getBhCtaButtonIconProps } from './BhCtaButton.utils';
import { useBrightHorizonsActionHandler } from '@rover/pages/src/bright-horizons/hooks/useBrightHorizonsActionHandler';

type BaseProps = {
  cta?: ButtonBh | null;
};

type LinkPropsWithOptionalHref = Omit<LinkProps, 'href' | 'children'> &
  Partial<Pick<LinkProps, 'href'>>;

export type Props = BaseProps &
  (
    | ({
        asLink: true;
      } & LinkPropsWithOptionalHref)
    | ({
        asLink?: false;
      } & ButtonProps)
  );

export const BhCtaButton = (props: Props): JSX.Element | null => {
  const { cta, asLink } = props;
  const actionProps = useBrightHorizonsActionHandler({
    action: cta?.action,
  });

  if (!cta) return null;

  const iconProps = getBhCtaButtonIconProps(cta);

  return (
    <Flex>
      {asLink ? (
        <Link
          underline
          variant={cta.linkType as LinkVariant}
          {...iconProps}
          {...(actionProps as LinkProps)}
          {...props}
        >
          {cta.title}
        </Link>
      ) : (
        <Button
          variant={cta.buttonType as ButtonVariants}
          hrefTarget={actionProps.target}
          {...iconProps}
          {...actionProps}
          {...props}
        >
          {cta.title}
        </Button>
      )}
    </Flex>
  );
};
